export default __webpack_public_path__ + "static/media/Doubly_List_Insertion_3.a8719352.gif";